export const ROLE_ADMIN = 'admin'
export const ROLE_ROOT = 'root'
export const ROLE_PARTNER = 'partner'
export const ROLE_VIEWER = 'viewer'
export const ROLE_MANAGER = 'manager'
export const ROLES_WITH_COMPANIES = [ROLE_ROOT, ROLE_PARTNER]
